import MyPageReg from "./MyPageReg"

export default  MyPageReg;
